document.addEventListener('DOMContentLoaded', () => {
    const langFlags = document.querySelectorAll('.language-flag');
    const langOptions = document.querySelectorAll('li[lang]');
    const langDropdown = document.querySelector('.localization-form__select');

    if (!langFlags || !langOptions || !langDropdown) {
        return;
    }

    langFlags.forEach((langFlag) => {
        langFlag.addEventListener('click', () => {
            langFlag.classList.toggle('open');
            langFlag.setAttribute('aria-expanded', (langFlag.classList.contains('open') ? 'true' : 'false'));
        });
    })

    langOptions.forEach((option) => {
        option.addEventListener('click', () => {
            selectLanguage(option);
        });

        option.addEventListener('keyup', (e) => {
            if (e.key === 'Enter') {
                selectLanguage(option);
            }
        });
    });

    document.addEventListener('click', (e) => {
        if (!e.target.closest('.language-flag')) {
            langFlags.forEach((langFlag) => {
                langFlag.classList.remove('open');
                langFlag.setAttribute('aria-expanded', 'false');
            });
        }
    });

    const selectLanguage = (option) => {
        langDropdown.value = option.lang;
        langDropdown.dispatchEvent(new Event('change'), { bubbles: true });
    }
});